import React, { Component, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, updateData, deleteItem} from './constants.js';

class Users extends Component {
  constructor(props){
    super(props);
    this.state = {
      data       : [],
      user_roles : [],
      isLoading  : true
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addUser = this.addUser.bind(this);
    this.editUser = this.editUser.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  async getUsers() {
    try {
      const response = await fetch('/api/users');
      const json = await response.json();
      this.setState({ data: json.users });
      console.log(json);
      this.setState({ user_roles: json.user_roles });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getUsers();
  }

  addUser() {
    this.setState({
      id        :"",
      username  :"",
      email     :"",
      is_active :"1",
      user_role :this.state.user_roles.length?this.state.user_roles[0].role_name:"",
      show      :true
    });
  }

  editUser(e) {
    const id = parseInt(e.target.id);
    const users = this.state.data;
    const selectedUser = users.filter(e=> e.id === id)[0];
    this.setState(selectedUser);
    this.setState({ show: true });
    console.log(this.state);
  }

  deleteUser(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/user/"+id)
    .then((response) => {
      console.log(response);
      this.getUsers();
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    delete data.data;
    delete data.isLoading;
    if(data.id){
      updateData('/api/user/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getUsers();
      });
    }else{
      postData('/api/user', data)
        .then((response) => {
          console.log(response);
          this.getUsers();
      });
    }
  }

  render(){
    if(!this.state.isLoading){
      const users = this.state.data;
      const user_list = users.map((user)=>
          <tr key={user.id} id={user.id}>
            <td>{user.username}</td>
            <td>{user.user_role}</td>
            <td>{user.email}</td>
            <td className={user.is_active?'text-success fw-bold':'fw-bold'}>{user.is_active?'Active':'Inactive'}</td>
            <td className="text-nowrap">
              <div className="row no-gutters">
                <div className="col">
                  <i id={user.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editUser}></i>
                </div>
                <div className="col">
                  <i id={user.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteUser}></i>
                </div>
              </div>
            </td>
          </tr>
      );
      const role_opts = this.state.user_roles.map((a) =>
        <option key={a.role_name} value={a.role_name}>{a.role_name}</option>
      );

      return(
          <>
            {this.state.show?(
              <div className="container-fluid">
                <div className="d-flex justify-content-center">
                   <div className="card shadow mb-2" style={{width:"450px"}}>
                       <div className="card-header py-3">
                           <h4 className="m-0 font-weight-bold text-light">Add / Edit User</h4>
                       </div>
                       <div className="card-body user-form">
                           <form id="userForm" className="user" onSubmit={this.handleSubmit} autoComplete="off">
                             <div className="row">
                               <div className="col-xs-12 col-md-12">
                                 <label>Username </label>
                                 <input type="text" className="form-control" name="username" value={this.state.username} onChange={this.handleInputChange} required />
                               </div>
                             </div>
                             <div className="row mt-2">
                               <div className="col-xs-12 col-md-12">
                                 <label>Email </label>
                                 <input type="email" className="form-control" name="email" value={this.state.email} onChange={this.handleInputChange} required />
                               </div>
                             </div>
                             <div className="row mt-2">
                               <div className="col-xs-12 col-md-12">
                                 <label>User role </label>
                                 <select className="form-select" name="user_role" value={this.state.user_role} onChange={this.handleInputChange}>
                                    {role_opts}
                                 </select>
                               </div>
                            </div>
                            <div className="row mt-2">
                               <div className="col-xs-12 col-md-12">
                                 <label>Status </label>
                                 <select className="form-select" name="is_active" value={this.state.is_active} onChange={this.handleInputChange}>
                                   <option value={0}> Inactive </option>
                                   <option value={1}> Active </option>
                                 </select>
                               </div>
                             </div>
                             <div className="form-group mt-2">
                               <input type="submit" id="user-submit" className="btn btn-bg-success mr-2" value="Submit" />
                               <button type="button" name="cancel" className="btn btn-danger" onClick={()=> this.setState({show:false})}>Cancel</button>
                             </div>
                           </form>
                       </div>
                   </div>
                </div>
              </div>
            ):(
              <div className="row">
                <div className="col-md-12 col-xs-12">
                      <div className="card shadow mb-2">
                          <div className="card-header py-3">
                              <h4 className="m-0 font-weight-bold text-white">Users</h4>
                          </div>
                          <div className="card-body">
                              <div className="table-responsive user-table">
                                  <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                      <thead>
                                          <tr>
                                              <th>Username</th>
                                              <th>Role</th>
                                              <th>Email</th>
                                              <th>Status</th>
                                              <th></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          {user_list}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                      <div className="d-flex justify-content-start">
                        <button className="btn btn-primary" onClick={this.addUser}><i className="fas fa-plus"></i> New User</button>
                        <button type="button" name="cancel" className="ml-3 btn btn-outline-dark" onClick={()=> this.props.setCurrentPage(null)}>Go back !</button>
                      </div>
                </div>
              </div>
            )}
          </>
      );
    }
  }
}

class UserRoles extends Component {
  constructor(props){
    super(props);
    this.state = {
      data           : [],
      show           : false,
      isLoading      : true
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRoleAccess = this.handleRoleAccess.bind(this);
    this.addUserRole = this.addUserRole.bind(this);
    this.deleteUserRole = this.deleteUserRole.bind(this);
  }

  async getUserRoles() {
    try {
      const response = await fetch('/api/user-roles');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  addUserRole() {
    this.setState({
      role_name    :"",
      acc_requests : 0,
      albums       : 0,
      complaints   : 0,
      mass_communications    : 0,
      events       : 0,
      fees         : 0,
      mom          : 0,
      newsletters  : 0,
      residents    : 0,
      violations   : 0,
      email_events : 0,
      show         :true
    });
  }

  deleteUserRole(e) {
    const id = e.target.id;
    deleteItem("/api/user-role/"+id)
    .then((response) => {
      console.log(response);
      this.getUserRoles();
    });
  }

  handleRoleAccess(event) {
    const target = event.target;
    const name = target.name;
    const value = (target.checked?1:0);
    const id = target.attributes.dataid.value;
    const data = { key: name, value: value };

    if(id){
      updateData('/api/user-role/'+id, data)
        .then((response) => {
          console.log(response);
          this.getUserRoles();
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    var value = "";
    if(target.type==="checkbox"){
      value = (target.checked?1:0);
    }else{
      value = target.value;
    }
    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    document.getElementById("userFormField").disabled = true;
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    delete data.data;
    delete data.isLoading;
    postData('/api/user-role', data)
      .then((response) => {
        console.log(response);
        this.getUserRoles();
    });
  }

  componentDidMount() {
    this.getUserRoles();
  }

  render(){
    if(!this.state.isLoading){
      const user_roles = this.state.data;
      const user_role_list = user_roles.map((role)=>
          <tr key={role.role_name} id={role.role_name}>
            <td>{role.role_name}</td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="acc_requests" onChange={this.handleRoleAccess} defaultChecked={role.acc_requests?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="albums" onChange={this.handleRoleAccess} defaultChecked={role.albums?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="complaints" onChange={this.handleRoleAccess} defaultChecked={role.complaints?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="mass_communications" onChange={this.handleRoleAccess} defaultChecked={role.mass_communications?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="events" onChange={this.handleRoleAccess} defaultChecked={role.events?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="fees" onChange={this.handleRoleAccess} defaultChecked={role.fees?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="mom" onChange={this.handleRoleAccess} defaultChecked={role.mom?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="newsletters" onChange={this.handleRoleAccess} defaultChecked={role.newsletters?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="residents" onChange={this.handleRoleAccess} defaultChecked={role.residents?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="violations" onChange={this.handleRoleAccess} defaultChecked={role.violations?true:false} />
              </div>
            </td>
            <td>
              <div className="custom-control custom-checkbox">
                <input type="checkbox" dataid={role.role_name} className="custom-control-input" name="email_events" onChange={this.handleRoleAccess} defaultChecked={role.email_events?true:false} />
              </div>
            </td>
            <td className="text-center">
              <i id={role.role_name} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteUserRole}></i>
            </td>
          </tr>
      );

      return (
        <>
          {this.state.show?(
            <div className="container-fluid d-flex justify-content-center">
                <div style={{width:"450px"}}>
                 {this.state.show &&
                   <div className="card shadow mb-2">
                       <div className="card-header py-3">
                           <h4 className="m-0 font-weight-bold text-light">Add User Role</h4>
                       </div>
                       <div className="card-body user-form">
                           <form id="userForm" className="user" onSubmit={this.handleSubmit} autoComplete="off">
                              <fieldset id="userFormField">
                                 <div className="row mb-3">
                                   <div className="col-xs-12 col-md-12">
                                     <label>Role Name </label>
                                     <input type="text" className="form-control" name="role_name" maxLength={20} value={this.state.role_name} onChange={this.handleInputChange} required />
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="acc_requests" onChange={this.handleInputChange} defaultChecked={this.state.acc_requests?true:false} />
                                       <label for="acc_requests"> ACC</label>
                                     </div>
                                   </div>
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="albums" onChange={this.handleInputChange} defaultChecked={this.state.albums?true:false} />
                                       <label for="albums"> Albums</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="complaints" onChange={this.handleInputChange} defaultChecked={this.state.complaints?true:false} />
                                       <label for="complaints"> Complaints</label>
                                     </div>
                                   </div>
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="mass_communications" onChange={this.handleInputChange} defaultChecked={this.state.mass_communications?true:false} />
                                       <label for="mass_communications"> Communications</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="events" onChange={this.handleInputChange} defaultChecked={this.state.events?true:false} />
                                       <label for="events"> Events</label>
                                     </div>
                                   </div>
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="fees" onChange={this.handleInputChange} defaultChecked={this.state.fees?true:false} />
                                       <label for="fees"> Fees</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="mom" onChange={this.handleInputChange} defaultChecked={this.state.mom?true:false} />
                                       <label for="mom"> Meeting Minutes</label>
                                     </div>
                                   </div>
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="newsletters" onChange={this.handleInputChange} defaultChecked={this.state.newsletters?true:false} />
                                       <label for="newsletters"> Newsletters</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="residents" onChange={this.handleInputChange} defaultChecked={this.state.residents?true:false} />
                                       <label for="residents"> Residents</label>
                                     </div>
                                   </div>
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="violations" onChange={this.handleInputChange} defaultChecked={this.state.violations?true:false} />
                                       <label for="violations"> Violations</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="row my-2">
                                   <div className="col-xs-12 col-md-6">
                                     <div className="custom-control custom-checkbox">
                                       <input type="checkbox" className="custom-control-input" name="email_events" onChange={this.handleInputChange} defaultChecked={this.state.email_events?true:false} />
                                       <label for="email_events"> Email events</label>
                                     </div>
                                   </div>
                                 </div>
                                 <div className="form-group mt-2">
                                   <input type="submit" id="user-submit" className="btn btn-bg-success" value="Submit" />
                                   <button type="button" name="cancel" className="btn btn-danger ml-3" onClick={()=> this.setState({show:false})}>Cancel</button>
                                 </div>
                              </fieldset>
                           </form>
                       </div>
                   </div>
                  }
                </div>
            </div>
          ):(
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-white">Users</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive user-role-table">
                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th>Role Name</th>
                                            <th>ACC</th>
                                            <th>Albums</th>
                                            <th>Complaints</th>
                                            <th>Communications</th>
                                            <th>Events</th>
                                            <th>Fees</th>
                                            <th>Meeting Minutes</th>
                                            <th>Newsletters</th>
                                            <th>Residents</th>
                                            <th>Violations</th>
                                            <th>Email events</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {user_role_list}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-start">
                      <button className="btn btn-primary" onClick={this.addUserRole}><i className="fas fa-plus"></i> New User Role</button>
                      <button type="button" name="cancel" className="ml-3 btn btn-outline-dark" onClick={()=> this.props.setCurrentPage(null)}>Go back !</button>
                    </div>
                </div>
            </div>
          )}
        </>
      );
    }
  }
}

function UserManagement() {
  let navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(null);
  return (
    <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                      {currentPage==="Users"?(
                        <>
                          <Users navigate={navigate} setCurrentPage={setCurrentPage} />
                        </>
                      ):currentPage==="UserRoles"?(
                        <>
                          <UserRoles navigate={navigate} setCurrentPage={setCurrentPage} />
                        </>
                      ):(
                        <>
                          <div className="mt-4 pt-5">
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="card shadow-sm">
                                <div className="card-body user-link text-center" onClick={()=>setCurrentPage("Users")}>
                                  <img className="user-form-images" src="/img/users.png" width="272" alt="Users" />
                                  <h5 className="mt-2 mb-0 fw-bold"> Users </h5>
                                </div>
                              </div>
                              <div className="card shadow-sm">
                                <div className="card-body user-link text-center" onClick={()=>setCurrentPage("UserRoles")}>
                                  <img className="user-form-images" src="/img/user_roles.png" width="272" alt="User_Roles" />
                                  <h5 className="mt-2 mb-0 fw-bold"> User Roles </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
    </>
  );
};

export { UserManagement };
